import SE289 from '../images/SE289.png';
import SE250 from '../images/SE250.png';
import SE302 from '../images/SE302.png';
import SE350 from '../images/SE350.png';
import SE388N from '../images/SE388N.png';
import SE358N from '../images/SE358N.png';
import SE355 from '../images/SE355.png';
import SE357N from '../images/SE357N.png';
import SE359N from '../images/SE359N.jpg';
import SE391F from '../images/SE391F.png';
import SE430 from '../images/SE430.png';
import SE449N from '../images/SE449N.png';
import SE488N from '../images/SE488N.jpg';
import SE800 from '../images/SE800.png';
import SETRIAL from '../images/SETRIAL.jpg';
import NXX90100 from '../images/NXX90100.png';
import NXX91100 from '../images/NXX91100.png';
import NXX92100 from '../images/NXX92100.png';
import NXX93100 from '../images/NXX93100.png';
import NXXTRIAL from '../images/NXXTRIAL.avif';

import productsData from './productsPricing.generated.json';

// Map image string references to actual imported images
const imageMap = {
    SE289,
    SE250,
    SE302,
    SE350,
    SE388N,
    SE358N,
    SE355,
    SE357N,
    SE359N,
    SE391F,
    SE430,
    SE449N,
    SE488N,
    SE800,
    SETRIAL,
    NXX90100,
    NXX91100,
    NXX92100,
    NXX93100,
    NXXTRIAL,
};

// Transform the JSON data to include actual image imports
const productsPricing = {};

Object.keys(productsData).forEach(locale => {
    productsPricing[locale] = productsData[locale].map(product => ({
        ...product,
        image: imageMap[product.image] || imageMap.SE800, // Default to SE800 if image not found
    }));
});

export default productsPricing;
